import './ContactForm.css'

const ContactForm = ({formData, 
    handleChange,
    //recaptchaSiteKey,
    //setRecaptchaToken,
    statusType,
    statusMessage,
    resetForm,
    resetStatus,
    onSend, 
    className,
}) => {
    
    return (
        <form 
            className={`contact-form ${className}`} 
            onSubmit={onSend}
        >
            <div className='contact-form-container'>
            
                <div className="enquiry-options">
                    <select
                        id="enquiry"
                        name="enquiryType"
                        value={formData.enquiryType}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select an enquiry type</option>
                        <option value="reportAnIssue">App Issues</option>
                        <option value="generalEnquiry">General Enquiries</option>
                        
                    </select>
                </div>
                
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder='Enter your email'
                ></input>
                
                <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder='Enter your message'
                />
                <div>
                </div>
                <div className='contact-form-status-message-container'>
                    <div className={`contact-form-status-message ${statusType ? statusType : 'no-status'}`}>
                        {statusMessage &&  (
                            <>
                                <span >{statusMessage}&nbsp;&nbsp;&nbsp;</span>
                                <button 
                                    className={`contact-form-ok-button ${statusType}`}
                                    onClick={ statusType == "success" ? resetForm : resetStatus }
                                    
                                >OK</button>
                            </>
                        )}
                    </div>
                </div>
                <button className="send-button" onClick={onSend}>
                    Send
                </button>
            </div>
        </form>
    )
}

export default ContactForm;